import React, { useId } from 'react'

interface ServiceSelectionButtonProps {
  selected: boolean;
  onClick: () => void;
  title: string;
  subtitle: string;
  ariaLabel: string;
  icon: React.ReactNode;
}

export function ServiceSelectionButton({
  selected,
  onClick,
  title,
  subtitle,
  ariaLabel,
  icon
}: ServiceSelectionButtonProps) {
  const gradientId = useId();
  
  return (
    <div
      className={`
        rounded-[19px] 
        ${selected ? 'bg-gradient-to-r from-[#2FC2A9] via-[#38CADA] to-[#21BECE] shadow-lg shadow-cyan-200/30 rounded-[16px]' : 'bg-gray-200/0'}
        ${!selected ? 'hover:shadow-md hover:shadow-emerald-100/40' : ''}
        p-[3px]
      `}
    >
      <button
        type="button"
        aria-label={ariaLabel}
        aria-pressed={selected}
        onClick={onClick}
        className={`
          flex flex-row items-center w-full
          min-w-[345px] max-w-[400px] min-h-[112px]
          bg-white rounded-[16px] text-gray-800 text-lg font-medium
          py-4 px-3 cursor-pointer outline-none
          transition-colors duration-300 ease-in-out
          focus-visible:outline-none
          ${!selected ? 'border border-gray-300' : ''}
        `}
      >
        <span
          className={`flex items-center justify-center text-3xl min-w-[1.8em] icon-wrapper ${selected ? 'icon-selected' : 'icon-unselected'}`}
          data-gradient-id={gradientId}
          aria-hidden="true"
        >
          <svg width="0" height="0" className="absolute">
            <defs>
              <linearGradient id={gradientId} x1="0%" y1="0%" x2="200%" y2="00%">
                <stop offset="0%" stopColor="#16D9E7" />
                <stop offset="60%" stopColor="#38DACF" />
                <stop offset="30%" stopColor="#19BFB1" />
              </linearGradient>
            </defs>
          </svg>
          {icon}
        </span>
        <div className="flex flex-col items-start flex-1 m-2">
          <span className="text-xl text-black font-medium mb-1 leading-tight">
            {title}
          </span>
          <span className="text-base text-gray-500 font-normal leading-snug">
            {subtitle}
          </span>
        </div>
      </button>
      
      {/* Separate styles for selected and unselected states */}
      <style>{`
        .icon-wrapper.icon-selected[data-gradient-id="${gradientId}"] svg path {
          fill: url(#${gradientId}) !important;
          transition: fill 0.3s ease;
        }
        .icon-wrapper.icon-unselected[data-gradient-id="${gradientId}"] svg path {
          fill: #6E787A !important;
          transition: fill 0.3s ease;
        }
      `}</style>
    </div>
  )
}